export const checkIsValidIban = (iban: string): boolean => /\bUA\d{27}\b/.test(iban);
